import { makeAutoObservable, runInAction } from "mobx";
import { Ticket_FormConfig } from "../../../../js/parsegenerated/Ticket_FormConfig";
import { SaveConfig } from "../../../administration";
import {
  CustomFieldConfigMap,
  SaveViews,
} from "../../../administration/ticket_creation/types/Config";

export class SaveConfigManager {
  private formConfig: Ticket_FormConfig = undefined;
  private config: SaveConfig["config"] = undefined;
  private view: SaveViews = undefined;
  private fieldPreparations: {
    [key in keyof CustomFieldConfigMap]?: boolean;
  } = {};

  constructor(formConfig: Ticket_FormConfig) {
    this.formConfig = formConfig;
    this.config = formConfig?.get("config")?.config;
    this.view = (formConfig?.get("view") as SaveViews) ?? "formular";
    makeAutoObservable(this);
  }

  get preparationsComplete() {
    return Object.values(this.fieldPreparations).every(Boolean);
  }

  /**
   * Get the config for a specific field by name
   * @param fieldName - name of the field to get the config for
   * @returns
   */
  getFieldConfig<T extends keyof CustomFieldConfigMap>(
    fieldName: T
  ): CustomFieldConfigMap[T] | undefined {
    if (!this.formConfig) return undefined;
    const config: CustomFieldConfigMap[T] = this.config.find(
      (config) => config.name === fieldName
    );
    return config;
  }

  getAllFieldConfigs(): Partial<CustomFieldConfigMap> {
    if (!this.formConfig) return {};
    return this.config.reduce((acc, config) => {
      acc[config.name] = config;
      return acc;
    }, {});
  }

  /**
   * Register a preparation for a specific field
   * @param fieldName - name of the field to register preparation for
   */
  registerPreperation(fieldName: keyof CustomFieldConfigMap) {
    if (this.fieldPreparations[fieldName]) return;
    runInAction(() => {
      this.fieldPreparations[fieldName] = false;
    });
  }

  /**
   * Mark a field as prepared
   * @param fieldName - name of the field to mark as prepared
   */
  markFieldPrepared(fieldName: keyof CustomFieldConfigMap) {
    runInAction(() => {
      this.fieldPreparations[fieldName] = true;
    });
  }

  /**
   * Get the view that should be used for the ticket creation form
   * @returns the view as string
   */
  getView(): SaveViews {
    return this.view ?? "formular";
  }
}
